import { Children, ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface VideoGridProps {
  children: ReactNode;
  className?: string;
}

export function VideoGrid({ children, className }: VideoGridProps) {
  const childCount = Children.count(children);
  const gridClass = getGridClass(childCount);

  return (
    <div className={cn('w-full h-full min-h-0 p-2 gap-2', gridClass, className)}>
      {children}
    </div>
  );
}

function getGridClass(count: number): string {
  switch (count) {
    case 0:
    case 1:
      // Use flex for centering, with child filling available space
      return 'flex items-center justify-center [&>*]:w-full [&>*]:h-full [&>*]:max-w-4xl [&>*]:max-h-full';
    case 2:
      return 'grid grid-cols-1 sm:grid-cols-2';
    case 3:
      // 3 participants: 2x2 grid with last tile centered by spanning both columns
      return 'grid grid-cols-2 grid-rows-2 [&>*:last-child]:col-span-2 [&>*:last-child]:mx-auto [&>*:last-child]:max-w-[50%]';
    case 4:
      return 'grid grid-cols-2 grid-rows-2';
    case 5:
    case 6:
      return 'grid grid-cols-2 sm:grid-cols-3 grid-rows-2';
    default:
      return 'grid grid-cols-2 sm:grid-cols-3 auto-rows-fr';
  }
}
